
export const LOCALE_CN = 'zh-CN';
export const LOCALE_EN = 'en-US"';

export const LANGUAGE = {
  en: {
    none_placeholder: 'None',
    placeholder: 'Search',
    radioGroupTitle: 'Overall',
    optionsGroupTitle: '',
    select_all: 'Select All',
    clear_all: 'Clear All',
    no_result: 'No result found',
    no_data: 'No data yet',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  cn: {
    none_placeholder: '无',
    placeholder: '搜索',
    radioGroupTitle: '聚合数据',
    optionsGroupTitle: '',
    select_all: '全选',
    clear_all: '清空',
    no_result: '无匹配项',
    no_data: '暂无数据',
    confirm: '确认',
    cancel: '取消',
  }
};
